import React, { useState } from 'react';
import {
  CardSchedulesProps,
  Course
} from '../../interfaces/propsCourseSchedule';
import ShowSchedulesMobile from './ShowSchedules';
import TextHelper from '@/core/helpers/TextHelper';
import ReusableButton from '@/presentation/reusables/Button';
import { TableCourse, TableHeader, TableBody } from '../Desktop/styled';
import useCourseSchedules from '@/presentation/hooks/useRegistrationTimes';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';

const CardCourseMobile = ({
  courses,
  styles,
  isMobile
}: CardSchedulesProps) => {
  const {
    fetchSchedules,
    getSchedulesForCourse,
    isLoadingSchedules,
    needsUpdate
  } = useCourseSchedules();
  const [openModal, setOpenModal] = useState(false);
  const [courseSelected, setCourseSelected] = useState<Course | null>(null);

  const handleSelectCourse = (course: Course) => {
    const courseNameCap = {
      ...course,
      name: TextHelper.capitalize(course.name, false, true)
    };
    setCourseSelected(courseNameCap);
    fetchSchedules(course.id);
    setOpenModal(true);
  };

  const handleClose = (courseId: string) => {
    needsUpdate(courseId);
    setCourseSelected(null);
    setOpenModal(false);
  };

  const CardStyle = {
    gap: '16px',
    padding: '12px',
    boxShadow: '0 1.2px 4px #EAEEF1',
    ...styles
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {courses.map((course) => (
        <WhiteContainer
          data-testid="card-course-mobile"
          style={CardStyle}
          key={course.id}
        >
          <TableCourse key={course.id}>
            <TableHeader isMobile={isMobile}>
              <div>
                {course.code} -{' '}
                {TextHelper.capitalize(course.name, false, true)}
              </div>
            </TableHeader>
            <TableBody
              expanded={false}
              style={{ gap: '8px', padding: '12px' }}
              isMobile
            >
              <div>Horas semanales: {course.hours}</div>
              <div>Créditos: {course.credits}</div>
              <div>Ciclo: {course.cicle}</div>
              <div>Tipo: {course.type}</div>
            </TableBody>
          </TableCourse>
          <ReusableButton
            data-testid="show-schedules-button"
            iconPrepend="chevron-down"
            onClick={() => handleSelectCourse(course)}
            style={{
              width: '100%',
              height: '40px',
              fontSize: '12px',
              padding: '0 10px'
            }}
            outlined
          >
            Ver horarios
          </ReusableButton>
        </WhiteContainer>
      ))}
      {courseSelected && (
        <ShowSchedulesMobile
          show={openModal}
          onClose={() => handleClose(courseSelected.id)}
          courseSelected={courseSelected}
          isLoadingSchedules={isLoadingSchedules[courseSelected.id]}
          schedulesSelected={getSchedulesForCourse(courseSelected.id)}
        />
      )}
    </div>
  );
};

export default CardCourseMobile;
